export const vakgebieden = {
  "Zorg en welzijn": "zw",
  Creatief: "cr",
  ICT: "it",
  Onderwijs: "on",
  Techniek: "tc",
};

export const niveaus = [
  "mbo niveau 2",
  "mbo niveau 3",
  "mbo niveau 4",
  "hbo associate degree",
  "hbo bachelor degree",
  "hbo post-bachelor",
  "hbo master degree",
  "hbo post-master",
  "wo",
  "overig",
];

export const duur = [
  "0-1 maand",
  "1-3 maanden",
  "4-6 maanden",
  "7-9 maanden",
  "10-12 maanden",
  "Meer dan 12 maanden",
  "Op maat",
];

export const type = [
  "Voltijd",
  "Deeltijd op locatie",
  "Duaal",
  "Cursus op locatie",
  "Online",
  "Blended",
  "Overig",
];

export const wizardType = {
  Voltijd: type[0],
  Deeltijd: [type[1], type[2], type[3]],
  Online: [type[4], type[5]],
};
